module.exports = __webpack_public_path__ + "static/TNM079___Modeling_And_Animation__Lab_4-4f063436f1eaf1cdc1752cd1f39fd139.pdf";